
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const services = [
  {
    icon: 'ri-building-line',
    title: 'Konstrukcje Stalowe',
    description:
      'Oferujemy swoje usługi w zakresie wykonawstwa i montażu wszelkiego rodzaju konstrukcji stalowych oraz montażu urządzeń głównie dla przemysłu energetycznego, hutniczego oraz budownictwa ogólnego.',
    image:
      'https://public.readdy.ai/ai/img_res/44cf08f2aff9841f48b51e5b82eb18ad.jpg',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Spawalnictwo',
    description:
      'W naszym zakładzie wykonujemy usługi według najnowszych technik spawalniczych metodami TIG, MIG, MMA. Spawanie, lutowanie, badanie ciśnieniowe i magnetyczne.',
    image:
      'https://readdy.ai/api/search-image?query=ultra%20close%20up%20welding%20sparks%20electric%20blue%20light%20in%20dark%20industrial%20environment%20precision%20metalwork%20photorealistic%208k%20cinematic%20macro%20photography%20dramatic%20lighting%20steel%20metal%20texture%20no%20text%20no%20logo&width=800&height=600&seq=service-welding-001&orientation=landscape',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Obróbka CNC',
    description:
      'Zrealizujemy każde nawet najbardziej nietypowe zlecenie, zarówno jednostkowe wytworzenie prototypu jak również produkcję mało i średnio seryjną. Zapewniamy doradztwo technologiczne.',
    image:
      'https://readdy.ai/api/search-image?query=cnc%20machining%20precision%20metal%20cutting%20close%20up%20with%20blue%20coolant%20and%20metallic%20chips%20industrial%20manufacturing%20photorealistic%208k%20quality%20dark%20background%20electric%20blue%20lighting%20professional%20photography%20no%20text%20no%20logo&width=800&height=600&seq=service-cnc-001&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Oprzyrządowanie',
    description:
      'Oferujemy Państwu możliwość wykonania oprzyrządowania dla zakładów przemysłowych. Precyzyjne narzędzia i urządzenia dostosowane do specyficznych potrzeb produkcyjnych.',
    image:
      'https://readdy.ai/api/search-image?query=precision%20industrial%20tools%20and%20equipment%20on%20metallic%20surface%20with%20dramatic%20blue%20lighting%20professional%20manufacturing%20setup%20photorealistic%208k%20quality%20dark%20background%20electric%20blue%20accents%20no%20text%20no%20logo&width=800&height=600&seq=service-tools-001&orientation=landscape',
  },
];

export default function ServicesReveal() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section id="uslugi" ref={ref} className="relative py-16 sm:py-24 lg:py-32 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
          className="text-center mb-10 sm:mb-16 lg:mb-20"
        >
          <span
            className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Nasze Usługi
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Zaawansowane <span className="text-[#00E5FF]">Rozwiązania</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              className="group relative bg-[#050505] border border-[#111111] overflow-hidden hover:border-[#00E5FF] transition-all duration-500"
            >
              <div className="relative h-44 sm:h-52 lg:h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/50 to-transparent"></div>
              </div>

              <div className="p-5 sm:p-6 lg:p-8">
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] mb-4 sm:mb-6 group-hover:bg-[#00E5FF] transition-colors duration-300">
                  <i
                    className={`${service.icon} text-2xl sm:text-3xl text-[#00E5FF] group-hover:text-[#050505] transition-colors duration-300`}
                  ></i>
                </div>

                <h3
                  className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-4 leading-tight"
                  style={{ fontFamily: 'Rajdhani, sans-serif' }}
                >
                  {service.title}
                </h3>

                <p
                  className="text-[#C0C7CF] text-xs sm:text-sm leading-relaxed mb-4 sm:mb-6 line-clamp-3 sm:line-clamp-none"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {service.description}
                </p>

                <a
                  href="/uslugi"
                  className="inline-flex items-center gap-2 text-[#00E5FF] font-semibold text-xs sm:text-sm group-hover:gap-4 transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  Dowiedz się więcej
                  <i className="ri-arrow-right-line text-base sm:text-lg"></i>
                </a>
              </div>

              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00E5FF] to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, delay: 0.8 }}
          className="text-center mt-10 sm:mt-16"
        >
          <a
            href="/uslugi"
            className="inline-block px-8 sm:px-12 py-4 sm:py-5 bg-transparent border-2 border-[#00E5FF] text-[#00E5FF] font-bold text-sm sm:text-lg hover:bg-[#00E5FF] hover:text-[#050505] transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Zobacz pełną ofertę
          </a>
        </motion.div>
      </div>
    </section>
  );
}
